export default function WhyB2BDealsLost() {
const reasons = [
    {
      title: 'Нет диагностики клиента',
      desc: 'Менеджеры начинают презентацию до того, как поняли реальную ситуацию клиента. Они не знают его текущих процессов, проблем, приоритетов и бюджета. Попытка продать «вслепую» почти всегда заканчивается отказом.',
    },
    {
      title: 'Не понимают процесс закупки клиента',
      desc: 'В B2B решение принимается не одним человеком, а целой группой. Процесс включает этапы: осознание потребности, формирование критериев, сбор предложений, оценка, согласование бюджета, утверждение. Менеджеры часто работают только с одним контактом, игнорируя остальных участников.',
    },
    {
      title: 'Не знают карту ЛПР',
      desc: 'В каждой B2B-сделке участвуют: инициатор, пользователь, влиятельное лицо, ЛПР и «блокиратор». У каждого — свои интересы, страхи и критерии. Без понимания этой структуры менеджер не может построить стратегию influence.',
    },
    {
      title: 'Говорят про продукт, а не про бизнес клиента',
      desc: 'Классическая ошибка: менеджер рассказывает про характеристики, преимущества и «мы лучшие на рынке». А клиенту нужно понять, как изменится его бизнес: вырастет ли выручка, снизятся ли издержки, ускорятся ли процессы.',
    },
    {
      title: 'Нет стратегии переговоров',
      desc: 'Большинство менеджеров не готовятся к переговорам: не формулируют цели, не продумывают аргументацию, не готовят ответы на возражения. Результат — переговоры идут по сценарию клиента, а не менеджера.',
    },
    {
      title: 'Нет управления следующими шагами',
      desc: 'Встреча завершается фразой «я вам пришлю КП». Дальше — тишина. Нет системы follow-up, нет промежуточных касаний, нет контроля движения сделки по воронке. Клиент остывает, появляются конкуренты.',
    },
    {
      title: 'Нет сопровождения сделки',
      desc: 'Сложная B2B-сделка может идти месяцами. За это время у клиента меняются приоритеты, появляются новые вводные. Менеджер должен постоянно «вести» сделку, добавляя ценность на каждом этапе.',
    },
    {
      title: 'Нет системности',
      desc: 'Каждый менеджер работает так, как привык. Нет единых стандартов, скриптов, регламентов. Компания не может масштабировать лучшие практики. Уход сильного менеджера — катастрофа для бизнеса.',
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gray-100 text-gray-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-article-line"></i>
            Экспертный материал
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему B2B сделки проигрываются
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            За 18 лет работы с корпоративными продажами я выделил системные причины, по которым компании теряют сделки. Вот ключевые из них.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-10">
          {reasons.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white font-bold text-sm">{String(i + 1).padStart(2, '0')}</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}